import * as React from "react";
import CustomerPanel from "./CustomerPanel";
import PaymentsPanel from "./PaymentsPanel";


type State = {
    company: string;
    ytunnus: string;
    customerRepresentative: string;
    errorText: string;
};

type Props = {
    startdate: string;
    currentpaidsalary: string;
    currenttyelpayment: string;
    yearlypayment: string;
    yearlysalary: string;
    paymentpercent: string;
    sitename: string;
    company: string;
    ytunnus: string;
    customerrepresentative: string;

    maintitle: string;
    paymenttitle: string;
    customertitle: string;
    paymenttextupper: string;
    paymenttextlower: string;
    customertext: string;
    tablefirsttitle: string;
    tablesecondtitle: string;
    tablethirdtitle: string;
};

export default class App extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            company: "constructor_state_company",
            errorText: "constructor_state_errorText",
            ytunnus: "constructor_state_ytunnus",
            customerRepresentative: "constructor_state_customerRepresentative",
        };
    }

    public componentDidMount() {
        //this.props.onMounted();
    }

    public render() {
        //this.setState({
        //    errorText: "jabadabadoo!!",
        //    company: "state_company",
        //    ytunnus: "state_ytunnus",
        //    customerRepresentative: "state_cusrep"
        //});
        return this.renderAppNormally();
    }

    public renderAppNormally = () => {
        //const data = {
        //    company1: this.state.company,
        //    customerRepresentative1: this.state.customerRepresentative,
        //    ytunnus1: this.state.ytunnus,
        //};
        return (
            <div className="insurance-estimation-app row custom-row">
                <PaymentsPanel
                    startdate={this.props.startdate}
                    currentpaidsalary={this.props.currentpaidsalary}
                    yearlysalary={this.props.yearlysalary}
                    company={this.props.company}
                    currenttyelpayment={this.props.currenttyelpayment}
                    yearlypayment={this.props.yearlypayment}
                    paymentpercent={this.props.paymentpercent}

                    maintitle={this.props.maintitle}
                    paymenttitle={this.props.paymenttitle}
                    paymenttextupper={this.props.paymenttextupper}
                    paymenttextlower={this.props.paymenttextlower}
                    tablefirsttitle={this.props.tablefirsttitle}
                    tablesecondtitle={this.props.tablesecondtitle}
                    tablethirdtitle={this.props.tablethirdtitle}
                    />
                <CustomerPanel
                    company={this.props.company}
                    customerRepresentative={this.props.customerrepresentative}
                    ytunnus={this.props.ytunnus}

                    customertitle={this.props.customertitle}
                    customertext={this.props.customertext}
                />
            </div >
        );
    }
}